// import { IconButton } from '@mui/material';
import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

export const StyledShapesContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginTop: '16px',
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      flexWrap: 'nowrap',
      overflow: 'auto',
      overscrollBehavior: 'contain',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  };
});

export const StyledShape = styled('button')<{ $isSelected?: boolean }>(({ $isSelected }) => {
  return {
    border: 'none',
    padding: '12px',
    backgroundColor: $isSelected ? COLORS.blue50 : COLORS.transparent,
    height: '60px',
    borderRadius: '16px',
    cursor: 'pointer',
  };
});

export const StyledShapeContainer = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px',
    backgroundColor: COLORS.white,
    boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.05)',
    borderRadius: '20px',
    position: 'relative',
  };
});

export const StyledGradientForm = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    gap: '16px',
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      flexDirection: 'column',
    },
  };
});

// export const StyledSwipeButton = styled(IconButton)(() => {
//   return {
//     position: 'absolute',
//     rotate: '90deg',
//     left: 'calc(50% - 30px)',
//     top: 'calc(100% + 7px)',
//     transform: 'translate(-50%, -50%)',
//     width: '40px',
//     height: '40px',
//     backgroundColor: COLORS.primary,
//     '&:hover': {
//       backgroundColor: COLORS.primary,
//     },
//     zIndex: 20,
//   };
// });

export const StyledListImgContainer = styled(StyledShape, {
  shouldForwardProp: (prop) => prop !== '$isSelected',
})<{ $isSelected?: boolean }>(({ $isSelected }) => {
  return {
    backgroundColor: $isSelected ? COLORS.blue50 : COLORS.transparent,
    height: '50px',
    padding: '16px',
    borderRadius: '16px',
    cursor: 'pointer',
  };
});

export const StyledBlock = styled('div')(() => {
  return {
    borderRadius: '20px',
    border: `1px solid ${COLORS.grey200}`,
    backgroundColor: COLORS.lightGray,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px',

    '&:last-of-type': {
      marginTop: '20px',
    },
  };
});
